export default function XOR() {
  return (
    <div className="p-4">
      <h1>XOR</h1>
    </div>
  );
}
